const gameType = {
    MATADOR: 'MATADOR',
    UNO: 'UNO',
};
export default gameType;
